// extracted by mini-css-extract-plugin
export default {"container":"CartItem_container__alzQ2","info":"CartItem_info__5C1gL"};